import { Loader2 } from 'lucide-react';
import type { AgentSession, AgentStatus } from '@/lib/agents/types';

const ACTIVE: AgentStatus[] = ['thinking', 'streaming', 'tool_calling'];

interface Props {
  session: AgentSession | undefined;
}

export function StatusLine({ session }: Props) {
  if (!session) return null;
  const isActive = ACTIVE.includes(session.status);
  if (!isActive) return null;

  return (
    <div className="flex items-center gap-1.5 px-1 pb-1.5 text-[12px] text-fg-subtle">
      <Loader2 className="h-3 w-3 animate-spin text-info" />
      <span className="text-fg-muted">{statusLabel(session.status)}</span>
    </div>
  );
}

function statusLabel(s: AgentStatus): string {
  switch (s) {
    case 'thinking': return 'Thinking…';
    case 'streaming': return 'Streaming…';
    case 'tool_calling': return 'Using tool…';
    default: return '';
  }
}
